import { render, staticRenderFns } from "./AtestoPesquisa.vue?vue&type=template&id=5669ad7a"
import script from "./AtestoPesquisa.vue?vue&type=script&lang=js"
export * from "./AtestoPesquisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports